export default __webpack_public_path__ + "3ddd25973a7654fff606dd0704fab724.png";